import styled from '@emotion/styled';
import {Dropdown} from '@bosch/react-frok';

export const DropdownInput = styled(Dropdown)`
    height: 3rem;
    width: 160px;
    margin-right: 0.5rem;
`;